<div>
  <div class="bg-vti-600 pb-32">
    <nav class="border-b border-vti-300 border-opacity-25 bg-vti-600 lg:border-none">
      <div class="mx-auto max-w-7xl px-2 sm:px-4 lg:px-8">
        <div class="relative flex h-16 items-center justify-between lg:border-b lg:border-vti-400 lg:border-opacity-25">
          <div class="flex items-center px-2 lg:px-0">
            <div class="flex-shrink-0">
              <img class="block h-8 w-auto" src="assets/images/logo-viridis.png" alt="Your Company" />
            </div>
            <div class="hidden lg:ml-10 lg:block">
              <div class="flex space-x-4">
                <a [routerLink]="['/summary']" [ngClass]="currentRoute() | vtiRouterMatcher: ['summary_ui']" (click)="closeDropdown()" i18n>Summary</a>
                <a
                  [routerLink]="['/investment-projects']"
                  [ngClass]="currentRoute() | vtiRouterMatcher: ['investment-projects_ui', 'investment-project_ui', 'feature_ui']"
                  (click)="closeDropdown()"
                  i18n
                  >Investment projects</a
                >
              </div>
            </div>
          </div>
          <div class="flex lg:hidden">
            <!-- Mobile menu button -->
            <button
              type="button"
              class="relative flex-shrink-0 rounded-full bg-vti-600 p-1 text-vti-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-vti-600 mr-2"
              (click)="navigateToNotif()"
            >
              @if (!newNotificationsCount()) {
                <vti-icons class="h-6 w-6" [icon]="'bell'" size="6" color="vti" colorTint="200"></vti-icons>
              } @else {
                <vti-icons class="h-6 w-6" [icon]="'bell-filled'" size="6"></vti-icons>
                <div class="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-vti-500 border-2 border-vti-200 rounded-full -top-2 -right-1">
                  {{ newNotificationsCount() }}
                </div>
              }
            </button>
            <button
              type="button"
              class="relative inline-flex items-center justify-center rounded-md bg-vti-600 p-2 text-vti-200 hover:bg-vti-500 hover:bg-opacity-75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-vti-600"
              aria-controls="mobile-menu"
              aria-expanded="false"
              (click)="showMenu()"
            >
              <span class="absolute -inset-0.5"></span>
              <span class="sr-only" i18n>Open main menu</span>
              @if (!mobileMenuVisible()) {
                <div>
                  <vti-icons class="h-6 w-6" [icon]="'burger'" size="6" color="vti" colorTint="200"></vti-icons>
                </div>
              } @else {
                <vti-icons class="h-6 w-6" [icon]="'x'" size="6" color="vti" colorTint="200"></vti-icons>
              }
            </button>
          </div>
          <div class="hidden lg:ml-4 lg:block">
            <div class="flex items-center">
              <!-- Profile dropdown -->
              <div class="relative ml-3 flex-shrink-0">
                <button
                  type="button"
                  class="relative flex rounded-full bg-vti-600 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-vti-600"
                  id="user-menu-button"
                  aria-expanded="false"
                  aria-haspopup="true"
                  (click)="triggerDropdown()"
                >
                  <img class="h-8 w-8 rounded-full" src="assets/images/profil.jpg" alt="" />
                </button>
                @if (userDropdownVisible()) {
                  <div
                    class="absolute right-0 z-50 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    <!-- Active: "bg-gray-100", Not Active: "" -->
                    <a [routerLink]="['/user']" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0" (click)="triggerDropdown()" i18n>Your Profile</a>
                    <div class="block px-4 py-2 text-sm text-gray-700 cursor-pointer" role="menuitem" tabindex="-1" id="user-menu-item-1" (click)="triggerLanguage()" i18n>Switch Language</div>
                    @if (languageVisible()) {
                      <div class="block px-12 py-2 text-sm text-gray-700 cursor-pointer" role="menuitem" tabindex="-1" id="user-menu-item-2" (click)="switchLanguage('en')" i18n>English</div>
                      <div class="block px-12 py-2 text-sm text-gray-700 cursor-pointer" role="menuitem" tabindex="-1" id="user-menu-item-3" (click)="switchLanguage('fr')" i18n>French</div>
                      <div class="block px-12 py-2 text-sm text-gray-700 cursor-pointer" role="menuitem" tabindex="-1" id="user-menu-item-4" (click)="switchLanguage('es')" i18n>Spanish</div>
                    }
                    @if (!this.biometricEnable()) {
                      <div class="block px-4 py-2 text-sm text-gray-700 cursor-pointer" role="menuitem" tabindex="-1" id="user-menu-item-5" (click)="activateBiometric()" i18n>Activate Biometric</div>
                    }
                    <div class="block px-4 py-2 text-sm text-gray-700 cursor-pointer" role="menuitem" tabindex="-1" id="user-menu-item-5" (click)="logout()" i18n>Sign out</div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (mobileMenuVisible()) {
        <div class="lg:hidden" id="mobile-menu">
          <div class="space-y-1 px-2 pb-3 pt-2">
            <a [routerLink]="['/summary']" [ngClass]="currentRoute() | vtiRouterMatcher: ['summary_ui'] : true" aria-current="page" (click)="hideMobileMenus()" i18n>Summary</a>
            <a
              [routerLink]="['/investment-projects']"
              [ngClass]="currentRoute() | vtiRouterMatcher: ['investment-projects_ui', 'investment-project_ui', 'feature_ui'] : true"
              (click)="hideMobileMenus()"
              i18n
              >Investment projects</a
            >
          </div>
          <div class="border-t border-vti-700 pb-3 pt-4">
            <div class="flex items-center px-5">
              <div class="flex-shrink-0">
                <img class="h-10 w-10 rounded-full" src="assets/images/profil.jpg" />
              </div>
              <div class="ml-3">
                <div class="text-sm font-medium text-white">{{ fullName() }}</div>
                <div class="text-sm font-medium text-vti-300">{{ userEmail() }}</div>
              </div>
              <button
                type="button"
                class="relative ml-auto flex-shrink-0 rounded-full bg-vti-600 p-1 text-vti-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-vti-600"
                (click)="navigateToNotif()"
              >
                @if (!newNotificationsCount()) {
                  <vti-icons class="h-6 w-6" [icon]="'bell'" size="6" color="vti" colorTint="200"></vti-icons>
                } @else {
                  <vti-icons class="h-6 w-6" [icon]="'bell-filled'" size="6"></vti-icons>
                  <div class="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-vti-500 border-2 border-vti-200 rounded-full -top-2 -right-1">
                    {{ newNotificationsCount() }}
                  </div>
                }
              </button>
            </div>
            <div class="mt-3 space-y-1 px-2">
              <a [routerLink]="['/user']" class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="hideMobileMenus()" i18n>Your Profile</a>
              <div class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="triggerMobileLanguage()" i18n>Switch Language</div>
              @if (languageMobileVisible()) {
                <div class="block rounded-md px-12 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="switchLanguage('en')" i18n>English</div>
                <div class="block rounded-md px-12 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="switchLanguage('fr')" i18n>French</div>
                <div class="block rounded-md px-12 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="switchLanguage('es')" i18n>Spanish</div>
              }
              @if (!this.biometricEnable()) {
                <div class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="activateBiometric()" i18n>Activate Biometric</div>
              }
              <div class="block rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-vti-500 hover:bg-opacity-75" (click)="logout()" i18n>Sign out</div>
            </div>
          </div>
        </div>
      }
    </nav>
  </div>
</div>
